import React from 'react';
import Select from 'react-select';

// class UpdatedSelect extends Select {
//
// }
function HOCUpdatedSelect(WrappedComponent) {
  return class Enhancer extends WrappedComponent {
    renderValue(valueArray, isOpen) {
      const renderLabel = this.props.valueRenderer || this.getOptionLabel;
      const ValueComponent = this.props.valueComponent;
      if (!valueArray.length) {
        return !this.state.inputValue
          ? <div className="Select-placeholder">
              {this.props.placeholder}
            </div>
          : null;
      }
      let onClick = this.props.onValueClick ? this.handleValueClick : null;
      if (this.props.multi && valueArray.length === 1) {
        return valueArray.map((value, i) =>
          <ValueComponent
            id={`${this._instancePrefix}-value-${i}`}
            instancePrefix={this._instancePrefix}
            disabled={this.props.disabled || value.clearableValue === false}
            key={`value-${i}-${value[this.props.valueKey]}`}
            onClick={onClick}
            onRemove={this.removeValue}
            value={value}
          >
            {renderLabel(value, i)}
            <span className="Select-aria-only">&nbsp;</span>
          </ValueComponent>,
        );
      } else if (this.props.multi && valueArray.length > 1) {
        return !this.state.inputValue
          ? <div className="Select-placeholder">
              {`${this.props.placeholder} (${valueArray.length})`}
            </div>
          : null;
      } else if (!this.state.inputValue) {
        if (isOpen) onClick = null;
        return (
          <ValueComponent
            id={`${this._instancePrefix}-value-item`}
            disabled={this.props.disabled}
            instancePrefix={this._instancePrefix}
            onClick={onClick}
            value={valueArray[0]}
          >
            {renderLabel(valueArray[0])}
          </ValueComponent>
        );
      }
    }

    render() {
      return super.render();
    }
  };
}

const UpdatedSelect = HOCUpdatedSelect(Select);

export default UpdatedSelect;



// WEBPACK FOOTER //
// ./src/desktop/components/UpdatedSelect/UpdatedSelect.js